import { render, staticRenderFns } from "./ServiceTypesCategoriesRegistryNewForm.vue?vue&type=template&id=e87659b4"
import script from "./ServiceTypesCategoriesRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./ServiceTypesCategoriesRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports